import React, { forwardRef, useMemo } from 'react'
import { TableAgInfinite } from '../table-builder/table-ag-infinite'
import { ColumnFormat, ColumnText } from '../table-builder/table-columns'
import { makeOrganizationGetRows } from './org-search-api'

// A server-paged, searchable grid of organizations (owner 2026-10-13): the
// table builder's infinite grid over content's organization search, company
// organizations first, personal after, a page at a time -- never the whole
// list. Its search box searches names. children: the page's own columns
// after Name and Type (usually a ColumnMenu with the row's actions).
export const OrganizationGrid = forwardRef(({ children, queryKey, emptyState, noMatchState, onRowClicked }, ref) => {
  const getRows = useMemo(() => makeOrganizationGetRows({ type: 'all' }), [])
  return (
    <TableAgInfinite ref={ref} queryKey={queryKey} onGetRows={getRows} emptyState={emptyState} noMatchState={noMatchState} onRowClicked={onRowClicked}>
      {[
        <ColumnText key="name" field="name" header="Name" />,
        <ColumnFormat key="type" field="personal" header="Type" fit="content" render={cell => (cell.value ? 'Personal' : 'Company')} />,
        ...React.Children.toArray(children)
      ]}
    </TableAgInfinite>
  )
})
